// ============================================
// Achievement Overlay — data sourced from achievementManager
// ============================================

import { events, Events } from '../engine/events.js';
import { achievementManager } from '../systems/achievements.js';
import { L } from '../systems/localization.js';

/** Map an achievement ID to one of 11 themed icon keys.
 *  Locked achievements always use the padlock. */
function getAchievementIcon(ach) {
    const id = ach.id;
    // Femininity milestones
    if (id.startsWith('milestone_fem')) return 'rose';
    // Submissiveness milestones + obedience
    if (id.startsWith('milestone_sub') || id === 'every_order_fulfilled') return 'collar';
    // Master / chastity
    if (id === 'first_chastity' || id === 'master_collar') return 'cage';
    // Sexual encounters
    if (id.includes('blowjob') || id.includes('anal') || id.includes('hookup') ||
        id === 'threesome' || id === 'glory_hole_discovery' || id === 'cuckolded' ||
        id.startsWith('free_use')) return 'lips';
    // Money / sugar daddy / kept
    if (id === 'rich' || id === 'broke' || id.includes('sugar') ||
        id.includes('kept_sissy') || id === 'rent_consequence') return 'money';
    // Work & career
    if (id.includes('shift') || id === 'uniform_accepted' || id.includes('club_') ||
        id.includes('maid') || id.includes('office')) return 'briefcase';
    // Beauty / salon / body mods
    if (id.includes('salon') || id === 'body_hairless' || id === 'long_hair' ||
        id === 'first_manicure' || id === 'first_piercing' || id === 'hrt_started' ||
        id === 'beautification') return 'lipstick';
    // Fame / streaming / camera
    if (id.includes('fame') || id.includes('stream') || id.includes('photo') ||
        id === 'all_categories' || id === 'domme_stream' || id === 'first_collab') return 'star';
    // Dating / relationships
    if (id.includes('date') || id.includes('dating') || id === 'sissy_profile' ||
        id === 'girlfriend_accepts') return 'heart';
    // Endings & finales
    if (id.startsWith('ending_')) return 'trophy';
    // Default — survival, exploration, upgrades, misc
    return 'calendar';
}

let _scope = null;

export const achievementsOverlayUI = {
    init() {
        const categories = document.getElementById('achievement-categories');
        const grid = document.getElementById('achievement-grid');
        if (!categories || !grid) return;

        if (!_scope) _scope = events.createScope('achievements-overlay');

        const cats = ['All', 'Milestone', 'Story', 'Gameplay'];
        const catL10nKeys = { All: 'achiev.cat.all', Milestone: 'achiev.cat.milestone', Story: 'achiev.cat.story', Gameplay: 'achiev.cat.gameplay' };
        let activeCat = 'All';

        const lockedText = () => {
            const k = 'achiev.locked_hint';
            const v = L.get(k);
            return v !== k ? v : 'Keep playing to unlock...';
        };
        const unlockedLabel = () => {
            const k = 'achiev.unlocked_label';
            const v = L.get(k);
            return v !== k ? v : 'unlocked';
        };

        function render() {
            const allAch = achievementManager.getAll();
            categories.innerHTML = '';
            for (const cat of cats) {
                const filtered = cat === 'All' ? allAch : allAch.filter(a => a.category === cat);
                const unlocked = filtered.filter(a => achievementManager.isUnlocked(a.id)).length;
                const btn = document.createElement('button');
                btn.className = 'achievement-cat-btn' + (cat === activeCat ? ' active' : '');
                const ck = catL10nKeys[cat];
                const catName = ck ? (L.get(ck) !== ck ? L.get(ck) : cat) : cat;
                btn.textContent = `${catName} (${unlocked}/${filtered.length})`;
                btn.addEventListener('click', () => { activeCat = cat; render(); });
                categories.appendChild(btn);
            }

            grid.innerHTML = '';
            const allUnlocked = allAch.filter(a => achievementManager.isUnlocked(a.id)).length;

            const header = document.createElement('div');
            header.className = 'achievement-progress-header';
            header.innerHTML = `
                <span>${allUnlocked} / ${allAch.length} ${unlockedLabel()}</span>
                <div class="achievement-progress-bar"><div class="achievement-progress-fill" style="width:${(allUnlocked/allAch.length)*100}%"></div></div>
            `;
            grid.appendChild(header);

            const filtered = activeCat === 'All' ? allAch : allAch.filter(a => a.category === activeCat);
            for (const ach of filtered) {
                const unlocked = achievementManager.isUnlocked(ach.id);
                const card = document.createElement('div');
                card.className = 'achievement-card' + (unlocked ? ' unlocked' : ' locked');
                // Audit D16: locked achievements were all "???" — identical for
                // 102 entries. Now show the category as a soft hint ("Femininity
                // ??", "Streaming ??", "Submission ??") so the player has a
                // sense of WHAT they're chasing without the spoiler. Title text
                // stays unrevealed; the category badge is the affordance.
                const localizedCat = L.get('achievement.cat.' + (ach.category || '').toLowerCase());
                const catLabel = (localizedCat && localizedCat !== 'achievement.cat.' + (ach.category || '').toLowerCase())
                    ? localizedCat
                    : (ach.category || 'Locked');
                const name = unlocked ? achievementManager.getLocalizedTitle(ach) : `${catLabel} …`;
                const desc = unlocked ? achievementManager.getLocalizedDesc(ach) : lockedText();
                const iconKey = unlocked ? getAchievementIcon(ach) : 'locked';
                // Match the grid-card CSS structure (v2): icon on top, title + desc below.
                card.innerHTML = `
                    <div class="achievement-icon"><img src="assets/images/UI/icon_ach_${iconKey}.png" alt=""></div>
                    <div class="achievement-title">${name}</div>
                    <div class="achievement-desc">${desc}</div>
                `;
                grid.appendChild(card);
            }
        }

        render();
        _scope.on(Events.OVERLAY_OPEN, (id) => {
            if (id === 'overlay-achievement') render();
        });
        _scope.on(Events.LOCALE_CHANGED, () => render());
    },

    destroy() {
        if (_scope) {
            _scope.destroy();
            _scope = null;
        }
    }
};
